import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import swal from 'sweetalert'
import { Modal, Button, FormGroup, FormControl, ControlLabel, Glyphicon } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'

import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'
import CitationEditor from './CitationEditor'

import { addPublication, getPublicationsWithFilters, getPublicationFieldsData } from '../reducers/managePublications'

class NewPublication extends Component {
  state = {
    citation: '',
    authors: [],
    year: '',
    month: '',
    journal_conference: '',
    therapeutic_areas: [],
    study_designs: [],
    publication_types: [],
    method_analysis_types: [],
    file: null,
    publication_url: '',
    publication_client: '',
    product: '',
    indication: '',
    data_sources: [],
    data_source_types: [],
    done_with_genesis: '',
    regulatory_related: '',
    // therapeutic_area: '',
    // analysis_type: '',
    // database: '',
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleChangeCitation = (e) => {
    this.setState({ "citation": e })
  }

  handleChangeDocument = (e) => {
    if (e && e.target && e.target.files && e.target.files[0]) {
      return this.setState({ file: e.target.files[0] })
    } else {
      const fileInput = document.getElementById("new-publication-file-input")
      fileInput.value = null
      this.setState({ file: null })
    }
  }

  handleCancel = () => {
    this.setState({
      citation: '',
      authors: [],
      year: '',
      month: '',
      journal_conference: '',
      therapeutic_areas: [],
      study_designs: [],
      publication_types: [],
      method_analysis_types: [],
      file: null,
      publication_url: '',
      publication_client: '',
      product: '',
      indication: '',
      data_sources: [],
      data_source_types: [],
      done_with_genesis: '',
      regulatory_related: ''
      // therapeutic_area: '',
      // analysis_type: '',
      // database: '',
    })

    this.props.toggleShow()
  }

  handleSave = () => {

    if (!this.state.citation || !this.state.year || !this.state.therapeutic_areas.length || !this.state.publication_types.length) {
      return swal({
        title: "Error",
        text: "Please fill out all required fields",
        icon: "error",
        button: "Continue",
      })
    }
    
    const keys = [
      'citation',
      'year',
      'month',
      'journal_conference',
      'product',
      'indication',
      'file',
      'publication_url',
      'publication_client',
      'done_with_genesis',
      'regulatory_related'
      // 'therapeutic_area',
      // 'publication_types',
      // 'analysis_type',
      // 'database',
    ]

    const formData = new FormData()

    keys.forEach(key => {
      if (key !== 'file') {
        if (typeof this.state[key] === "string") {
          let strippedValue = this.state[key]
            .replace(/(?:\\[rn]|[\r\n])\s+/g, " ")
            .replace("<p>", "")
            .replace("</p>", "")
            .trim()
          formData.append(key, strippedValue)
        } else {
          formData.append(key, this.state[key])
        }
      } else if (key === 'file' && this.state.file !== null ) {
        formData.append('document', this.state.file)
      }
    })

    formData.append('created_by', this.props.currentUser)

    if (this.state.authors.length) {
      this.state.authors.forEach(author => formData.append('authors', author.url))
    }

    if (this.state.therapeutic_areas.length) {
      this.state.therapeutic_areas.forEach(therapeuticArea => formData.append('therapeutic_areas', therapeuticArea.url)) 
    }

    if (this.state.study_designs.length) {
      this.state.study_designs.forEach(studyDesign => formData.append('study_designs', studyDesign.url))
    }

    if (this.state.data_sources.length) {
      this.state.data_sources.forEach(dataSource => {
        if (!!dataSource.customOption) {
          formData.append('new_data_sources', dataSource.name)
        } else {
          formData.append('data_sources', dataSource.url)
        }
      })
    }

    if (this.state.data_source_types.length) {
      this.state.data_source_types.forEach(dataSourceType => {
        if (!!dataSourceType.customOption) {
          formData.append('new_data_source_types', dataSourceType.name)
        } else {
          formData.append('data_source_types', dataSourceType.url)
        }
      })
    }

    if (this.state.method_analysis_types.length) {
      this.state.method_analysis_types.forEach(methodAnalysisType => {
        if (!!methodAnalysisType.customOption) {
          formData.append('new_method_analysis_types', methodAnalysisType.name)
        } else {
          formData.append('method_analysis_types', methodAnalysisType.url)
        }
      })
    }

    if (this.state.publication_types.length) {
      this.state.publication_types.forEach(publicationType => {
        formData.append('publication_types', publicationType.url)
      })
    }

    swal({
      text: "Saving the publication... Please stand by.",
      icon: require("../../../static/images/spinner.gif"),
      button: false,
      closeOnClickOutside: false,
    })
    axios({
      method: "POST",
      url: `${getServerURL()}publications/`,
      data: formData,
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
    })
    .then(response => {
      swal({
        title: "Success",
        text: "Publication has been saved",
        icon: "success",
        button: "Continue",
      })
      .then(() => {
        const { authors } = this.state

        const publication = {...response.data, authors }

        this.handleCancel()
        this.props.getPublicationsWithFilters(1, this.props)
        this.props.getPublicationFieldsData()
        return this.props.history.push(`/publications/${publication.id}`)
      })
    })
    .catch(error => {
      const message = "There was an error saving your publication"
      return handleErrorFetchingData(error, message)
    })
  }

  mapFormFields = () => {
    const formFields = [
      'citation',
      'authors',
      'year',
      'month',
      'journal_conference',
      'product',
      'indication',
      'therapeutic_areas',
      'study_designs',
      'publication_types',
      'method_analysis_types',
      'file',
      'publication_url',
      'publication_client',
      'data_sources',
      'data_source_types',
      'done_with_genesis',
      'regulatory_related'
      // 'therapeutic_area',
      // 'analysis_type',
      // 'database',
    ]

    return formFields.map(field => {

      let fieldName
      if (field === 'publication_url') {
        fieldName = 'URL'
      } else if (field === 'publication_client') {
        fieldName = 'Client'
      } else if (field === 'done_with_genesis') {
        fieldName = 'Done with Genesis / Sirius / MAT'
      } else {
        fieldName = field.split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
      }

      if (field === 'citation') {
        return (
          <FormGroup key={`form-field-${field}`}>
            <ControlLabel>
              {fieldName}{field === 'citation' || field === 'year' ?
                <span className="required">*</span>
                :
                null
              }
            </ControlLabel>
            <CitationEditor 
              citation={this.state.citation}
              handleChange={this.handleChangeCitation}
            />
          </FormGroup>
        )
      } else if (field === 'authors') {
        return (
          <FormGroup key={`form-field-${field}`}>
            <ControlLabel>
              Genesis Authors
            </ControlLabel>
            <Typeahead
              id="NewPublicationAuthorFilterTypeahead"
              clearButton
              labelKey={(author) => `${author.first_name} ${author.last_name}`}
              multiple
              selected={this.state.authors}
              options={this.props.genesisUsers}
              placeholder="Enter Genesis author(s)"
              onChange={(authors) => this.handleChange({target: {name: 'authors', value: authors}})}
            />
          </FormGroup>
        )
      } else if (field === 'therapeutic_areas') {
        return (
          <FormGroup key={`form-field-${field}`}>
            <ControlLabel>
              Therapeutic Areas<span className="required">*</span>
            </ControlLabel>
            <Typeahead
              id="NewPublicationTherapeuticAreasFilterTypeahead"
              clearButton
              labelKey={(therapeuticArea) => `${therapeuticArea.name}`}
              multiple
              selected={this.state.therapeutic_areas}
              options={this.props.therapeuticAreas}
              placeholder="Select Therapeutic Area(s)"
              onChange={(therapeuticAreas) => this.handleChange({target: {name: 'therapeutic_areas', value: therapeuticAreas}})}
            />
          </FormGroup>
        )
      } else if (field === 'study_designs') {
        return (
          <FormGroup key={`form-field-${field}`}>
            <ControlLabel>
              Study Designs
            </ControlLabel>
            <Typeahead
              id="NewPublicationStudyDesignsFilterTypeahead"
              clearButton
              labelKey="name"
              multiple
              selected={this.state.study_designs}
              options={this.props.studyDesigns}
              placeholder="Select Study Design(s)"
              onChange={(studyDesigns) => this.handleChange({target: {name: 'study_designs', value: studyDesigns}})}
            />
          </FormGroup>
        )
      } else if (field === 'data_sources') {
        return (
          <FormGroup key={`form-field-${field}`}>
            <ControlLabel>
              Data Sources
            </ControlLabel>
            <Typeahead
              id="NewPublicationDataSourcesFilterTypeahead"
              clearButton
              labelKey="name"
              multiple
              allowNew={true}
              selected={this.state.data_sources}
              options={this.props.dataSources}
              placeholder="Select Data Source(s)"
              onChange={(dataSources) => this.handleChange({target: {name: 'data_sources', value: dataSources}})}
            />
          </FormGroup>
        )
      } else if (field === 'data_source_types') {
        return (
          <FormGroup key={`form-field-${field}`}>
            <ControlLabel>
              Data Source Types
            </ControlLabel>
            <Typeahead
              id="NewPublicationDataSourceTypesFilterTypeahead"
              clearButton
              labelKey="name"
              multiple
              allowNew={true}
              selected={this.state.data_source_types}
              options={this.props.dataSourceTypes}
              placeholder="Select Data Source Type(s)"
              onChange={(dataSourceTypes) => this.handleChange({target: {name: 'data_source_types', value: dataSourceTypes}})}
            />
          </FormGroup>
        )
      } else if (field === 'method_analysis_types') {
        return (
          <FormGroup key={`form-field-${field}`}>
            <ControlLabel>
              Method / Analysis Types
            </ControlLabel>
            <Typeahead
              id="NewPublicationMethodAnalysisTypesFilterTypeahead"
              clearButton
              labelKey="name"
              multiple
              allowNew={true}
              selected={this.state.method_analysis_types}
              options={this.props.methodAnalysisTypes}
              placeholder="Select Method / Analysis Type(s)"
              onChange={(methodAnalysisTypes) => this.handleChange({target: {name: 'method_analysis_types', value: methodAnalysisTypes}})}
            />
          </FormGroup>
        )
      } else if (field === 'publication_types') {
        return (
          <FormGroup key={`form-field-${field}`}>
            <ControlLabel>
              Publication Types<span className="required">*</span>
            </ControlLabel>
            <Typeahead
              id="NewPublicationPublicationTypesFilterTypeahead"
              clearButton
              labelKey="name"
              multiple
              selected={this.state.publication_types}
              options={this.props.publicationTypes}
              placeholder="Select Publication Type(s)"
              onChange={(publicationTypes) => this.handleChange({target: {name: 'publication_types', value: publicationTypes}})}
            />
          </FormGroup>
        )
      } else if (field === 'file') {
        return (
          <FormGroup key={`form-field-${field}`}>
            <ControlLabel>
              Document
            </ControlLabel>
            <br/>
            <input
              type="file"
              id="new-publication-file-input"
              style={{display: 'inline-block'}}
              onChange={this.handleChangeDocument}
            />
            {this.state.file ?
              <Button
                className="edit-icon"
                style={{display: 'inline-block'}}
                onClick={this.handleChangeDocument}
              >
                <Glyphicon glyph="remove" />
              </Button>
              :
              null
            }
          </FormGroup>
        )
      } else if (field === 'month') {
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

        const monthOptions = [
          <option key='empty-month-option' value="">-</option>,
          ...months.map(month => <option key={month} value={month}>{month}</option>)
        ]

        return (
          <FormGroup key={`form-field-${field}`}>
            <ControlLabel>
              {fieldName}{field === 'citation' || field === 'year' ?
                <span className="required">*</span>
                :
                null
              }
            </ControlLabel>
            <FormControl
              componentClass='select'
              name={field}
              value={this.state[field]}
              placeholder={`Enter ${fieldName}`}
              onChange={this.handleChange}
            >
              {monthOptions}
            </ FormControl>
          </FormGroup>
        )
      } else if (field === 'done_with_genesis' || field === 'regulatory_related') {
        const choices = ['Yes', 'No']

        const yesNoOptions = [
          <option key='empty-choice-option' value="">-</option>,
          ...choices.map(choice => <option key={choice} value={choice}>{choice}</option>)
        ]

        return (
          <FormGroup key={`form-field-${field}`}>
            <ControlLabel>
              {fieldName}{field === 'citation' || field === 'year' ?
                <span className="required">*</span>
                :
                null
              }
            </ControlLabel>
            <FormControl
              componentClass='select'
              name={field}
              value={this.state[field]}
              placeholder={`Enter ${fieldName}`}
              onChange={this.handleChange}
            >
              {yesNoOptions}
            </ FormControl>
          </FormGroup>
        )
      } else {
        return (
          <FormGroup key={`form-field-${field}`}>
            <ControlLabel>
              {fieldName}{field === 'citation' || field === 'year' ?
                <span className="required">*</span>
                :
                null
              }
            </ControlLabel>
            <FormControl
              name={field}
              value={this.state[field]}
              placeholder={`Enter ${fieldName}`}
              onChange={this.handleChange}
            />
          </FormGroup>
        )
      }
    })
  }

  render() {

    const { show } = this.props

    return (
      <Modal
        id="NewPublication"
        show={show}
      >
        <Modal.Header closeButton onHide={this.handleCancel}>
          <Modal.Title>
            New Publication
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            <span className="required">*</span> denotes a required field
          </p>

          {this.mapFormFields()}

        </Modal.Body>

        <Modal.Footer>
          <Button onClick={this.handleCancel}>
            Cancel
          </Button>
          <Button onClick={this.handleSave}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    // DATA
    genesisUsers: state.manageLogin.genesisUsers,
    clients: state.manageLogin.clients,
    currentUser: state.manageLogin.user,
    therapeuticAreas: state.managePublications.therapeuticAreas,
    studyDesigns: state.managePublications.studyDesigns,
    dataSources: state.managePublications.dataSources,
    dataSourceTypes: state.managePublications.dataSourceTypes,
    methodAnalysisTypes: state.managePublications.methodAnalysisTypes,
    publicationTypes: state.managePublications.publicationTypes,
    // FILTERS & SORTING //
    publicationsSearchTerm: state.managePublications.publicationsSearchTerm,
    publicationsSortType: state.managePublications.publicationsSortType,
    publicationsApprovalStatusSortType: state.managePublications.publicationsApprovalStatusSortType,
    publicationsApprovalStatusFilter: state.managePublications.publicationsApprovalStatusFilter,
    publicationsAuthorFilter: state.managePublications.publicationsAuthorFilter,
    publicationsYearFilter: state.managePublications.publicationsYearFilter,
    publicationsClientFilter: state.managePublications.publicationsClientFilter,
    publicationsProductFilter: state.managePublications.publicationsProductFilter,
    publicationsIndicationFilter: state.managePublications.publicationsIndicationFilter,
    publicationsTherapeuticAreasFilter: state.managePublications.publicationsTherapeuticAreasFilter,
    publicationsStudyDesignsFilter: state.managePublications.publicationsStudyDesignsFilter,
    publicationsPublicationTypeFilter: state.managePublications.publicationsPublicationTypeFilter,
    publicationsMethodAnalysisTypesFilter: state.managePublications.publicationsMethodAnalysisTypesFilter,
    publicationsDataSourcesFilter: state.managePublications.publicationsDataSourcesFilter,
    publicationsDataSourceTypesFilter: state.managePublications.publicationsDataSourceTypesFilter,
  }
}

const mapDispatchToProps = {
  addPublication,
  getPublicationsWithFilters,
  getPublicationFieldsData
}

export default connect(mapStateToProps, mapDispatchToProps)(NewPublication)



// WEBPACK FOOTER //
// ./src/routes/publications/components/NewPublication.js